import apiFetch from '../apiFetch'

export default function (token, includeDeleted = false) {
  return apiFetch({ endPoint: 'fuel?includeDeleted=' + includeDeleted, method: 'GET', body: null, token: token })
}
